import React, { createContext, useState } from "react";

interface LockEventSessionsContextType {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  element: any;
  setElement: (element: any) => void;  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;
  modelId: any;
  setModelId: (modelId: any) => void;
}

export const LockEventSessionsContext = createContext<LockEventSessionsContextType>({  
  showModal: false,
  setShowModal: () => {},
  element: null,
  setElement: () => {},
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  modelId: null,
  setModelId: () => {},
});

interface LockEventSessionsProviderProps {
  children: React.ReactNode;
}

export const LockEventSessionsProvider: React.FC<LockEventSessionsProviderProps> = ({
  children,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [element, setElement] = useState<any>(null);
  const [backendFormErrors, setBackendFormErrors] = useState<any>({});
  const [modelId, setModelId] = useState<any>(null);


  const value = {
    showModal,
    setShowModal,
    element,
    setElement,
    backendFormErrors,
    setBackendFormErrors,
    modelId,
    setModelId,
  };
  return (
    <LockEventSessionsContext.Provider value={value}>
      {children}
    </LockEventSessionsContext.Provider>
  );
};
